import Link from '@alltrails/denali/components/Link';
import type { Map } from '@alltrails/types/Map';
import { getUrlFromSlug } from '../../utils/cardLinks';
import LengthAndDuration from '../LengthAndDuration';
import styles from './styles/styles.module.scss';

type MapMetadataProps = {
  map: Map;
  displayAttribution?: boolean;
  isFirstParty?: boolean;
  useMetric?: boolean;
  decimalPlaces?: number;
  openInNewTab?: boolean;
  baseUrl?: string;
};

const MapMetadata = ({
  map,
  displayAttribution = false,
  isFirstParty,
  useMetric,
  decimalPlaces = 1,
  openInNewTab,
  baseUrl
}: MapMetadataProps) => {
  const { name, locationName, locationSlug, minutes, meters, user } = map;
  const testIdPrefix = `MapCard_${name}`;
  const locationElement: React.ReactNode = locationSlug ? (
    <Link
      className={styles.link}
      size="sm"
      variant="secondary"
      href={getUrlFromSlug(locationSlug, baseUrl)}
      target={openInNewTab ? '_blank' : undefined}
    >
      {locationName}
    </Link>
  ) : (
    locationName
  );

  return (
    <div>
      <div className={styles.title} data-testid={`${testIdPrefix}_Title`}>
        {name}
      </div>
      <div className={styles.subtext} data-testid={`${testIdPrefix}_Location`}>
        {locationElement}
      </div>
      <div className={styles.subtext} data-testid={`${testIdPrefix}_Stats`}>
        <LengthAndDuration
          meters={meters}
          minutes={minutes}
          useMetric={useMetric}
          decimalPlaces={decimalPlaces}
          averageTimeToComplete={map?.averageTimeToComplete}
        />
      </div>
      {isFirstParty || displayAttribution ? null : (
        <div className={styles.subtext} data-testid={`${testIdPrefix}_User`}>
          {user.name}
        </div>
      )}
    </div>
  );
};

export default MapMetadata;
